import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseEntityService } from 'src/app/shared/services/base-entity.service';
import { environment } from 'src/environments/environment';
import {
    ProcessCalculationStatistic,
    ProcessCalculationStatisticFactory
} from '../../../shared/models/process-calculation-statistic';
import Response = ZoningAPI.Response;
import IProcessCalculationStatisticDTO = ZoningAPI.IProcessCalculationStatisticDTO;
import { ProcessCalculationStatisticMapper } from 'src/app/shared/mappers/process-calculation-statistic-mapper';

const API_ENDPOINT = environment.ZONAR_API_URL + '/process-calculation-statistics';

@Injectable({
    providedIn: 'root'
})
export class ProcessCalculationStatisticService extends BaseEntityService<ProcessCalculationStatistic> {
    mapper = new ProcessCalculationStatisticMapper();

    constructor(private readonly http: HttpClient) {
        super(ProcessCalculationStatisticFactory);
    }

    getProcessCalculationStatistics(state_env: string, processId: string): Observable<ProcessCalculationStatistic[]> {
        if (!state_env || !processId) {
            return of();
        }
        const params = new HttpParams({
            fromObject: {
                state_env,
                processId
            }
        });
        return this.http
            .get<Response>(`${API_ENDPOINT}`, { params })
            .pipe(
                map(response => {
                    return (response.data as IProcessCalculationStatisticDTO[]).map(dto =>
                        this.initEntity(this.mapper.fromDTO(dto))
                    );
                })
            );
    }
}
